import {useEffect} from "react";

export const useFiltersHook = ({
                                   whoCategories,
                                   eventCategories,
                                   locationCategories,
                                   priceCategories,
                                   productCategories,
                                   queryWho,
                                   queryEvent,
                                   queryLocation,
                                   queryPrice,
                                   queryCategory,
                                   defaultValues,
                                   setDefaultValues
                               }) => {
    useEffect(() => {
        const updateDefaultValues = {};

        if (queryCategory) {
            const foundCategory = productCategories.find((category) => category.id === parseInt(queryCategory));
            if (foundCategory) {
                updateDefaultValues.category = foundCategory;
            }
        }

        if (queryWho) {
            const foundWho = whoCategories.find((category) => category.id === parseInt(queryWho));
            if (foundWho) {
                updateDefaultValues.who_category = foundWho;
            }
        }

        if (queryEvent) {
            const foundEvent = eventCategories.find((category) => category.id === parseInt(queryEvent));
            if (foundEvent) {
                updateDefaultValues.event_category = foundEvent;
            }
        }

        if (queryLocation) {
            const foundLocation = locationCategories.find((category) => category.id === parseInt(queryLocation));

            if (foundLocation) {
                updateDefaultValues.location = foundLocation;
            }
        }

        if (queryPrice) {
            const foundPrice = priceCategories.find((category) => category.id === parseInt(queryPrice));
            if (foundPrice) {
                updateDefaultValues.price = foundPrice;
            }
        }

        if (Object.keys(updateDefaultValues).length > 0) {

            setDefaultValues({
                ...defaultValues,
                ...updateDefaultValues,
            });
        }
    }, [queryWho, queryEvent, queryLocation, queryPrice]);
}